import React from 'react';

const PartnerDetails: React.FC<any> = (props) => {
  const { data, refresh } = props

  return (
    <div style={{marginBottom: 20}}>
      <div style={{marginTop: 20}}>
        <b>Titre de la proposition:</b> {data.title}
      </div>

      <div style={{marginTop: 10}}>
        <b>Contact:</b> {data.asso.email} - {data.asso.phone}
      </div>

      <div style={{marginTop: 10}}>
        <b>Message:</b> {data.message}
      </div>

      { !!data.work &&
        <div style={{marginTop: 30}}>
          <b>Fichier:</b> <a href={data.work} target="_blank">Ouvrir le fichier</a>
        </div>
      }

    </div>
  )
}

export default PartnerDetails